module.exports = __webpack_public_path__ + "static/media/pdfAntiFraude.3676a9fb.pdf";